<template>
  <div v-show="pageSync">
    <div
      class="balance-wrapper"
      :class="[
        getDeviceBgImg,
        { 'mini-balance-wrapper': getInMiniStyle && layerType !== 'wallet' },
        { 'mini-balance-wallet-layer-wrapper': getInMiniStyle && layerType === 'wallet' },
        { 'dp-ios': system === 'iphone' && app === 'dianping-nova' },
      ]"
    >
      <!-- title-bar -->
      <div class="func-and-title">
        <div class="nav-content">
          <title-bar
            v-if="isNative"
            class="main-nav nav-fixed title-bar-comp"
            :class="{ 'linear-gradient': titleBarBg }"
            :show-more="showMore"
            :customer-service-url="pageData.customerServiceUrl"
            :title="titleBarText"
            :other-handle="true"
            @click-left="closePage"
            @to-click-right="toClickMore"
          />
          <div
            v-if="isMiniProgramWalletLayer"
            class="miniprogram-titlebar"
            :class="{ 'miniprogram-titlebar-scrolled': titleBarBg }"
          >
            <div class="title">{{ titleBarText }}</div>
            <div class="close-float" @click="closeWalletLayer" />
          </div>
        </div>
      </div>

      <!-- 余额主区域 -->
      <main-info
        v-pgy-collect="{ moduleName: 'main-info-block' }"
        :page-data="pageData"
        :show-bind-card-entry="showBindCardEntry"
        :pgy-env="runtime"
        @setGuideInfo="setGuideInfo"
        @guideRefreshPage="refreshPageData"
      />
      <!-- 余额明细 -->
      <balance-detail
        ref="balanceDetail"
        v-pgy-collect="{ moduleName: 'balance-detail' }"
        :detail="balanceDetail"
        class="balanceDetail"
      />
      <!-- 心智教育区 -->
      <div v-show="cognitionVisible" class="cognition">
        <!-- 金刚位 -->
        <Pgy
          v-pgy-collect="{ moduleName: 13506 }"
          class="pgy-13506"
          :pos-id="13506"
          @update:visible="onCognitionDiamondPgyVisibleChange"
        />
        <div v-show="cognitionDiamondPgyVisible && cognitionNoticePgyVisible" class="divide" />
        <!-- 公告栏 -->
        <Pgy
          v-show="cognitionNoticePgyVisible"
          v-pgy-collect="{ moduleName: 13505 }"
          class="pgy-13505"
          :pos-id="13505"
          @update:visible="onCognitionNoticePgyVisibleChange"
        />
      </div>
      <!-- PGY-SDK 做任务赚余额（老样式） -->
      <div v-show="borrowPgyVisible" ref="zrwzye" class="pgy-12826">
        <Pgy
          v-if="isNative"
          v-pgy-collect="{ moduleName: 12826 }"
          :pos-id="12826"
          @update:visible="onBorrowVisibleChange"
        />
      </div>
      <!-- PGY-SDK 做任务赚余额（新样式） -->
      <div v-show="showNewTaskPgy" class="pgy-mid-promotion">
        <div class="pgy-12167-title">做任务赚余额</div>
        <Pgy v-pgy-collect="{ moduleName: 12167 }" class="pgy-12167" :pos-id="12167" @custom-event="onCustomEvent" />
      </div>
      <!-- 天天领余额，金刚位模块 -->
      <div ref="ttlye">
        <Pgy
          v-if="isNative"
          v-pgy-collect="{ moduleName: 13271 }"
          class="pgy-13271"
          :pos-id="13271"
          :options="{
            isPage: false,
            earnedMoney: rewardAmount,
          }"
          @adClick="adClick"
        />
      </div>
      <!-- PGY-SDK 精选活动-->
      <div ref="jxhd">
        <Pgy v-if="isNative" v-pgy-collect="{ moduleName: 12835 }" class="pgy-12835" :pos-id="12835" />
      </div>
      <!-- 鲸湾的通用半浮层 鲸湾自己唤起，不需要业务方接入 -->
      <!-- 余额营销弹窗 产品要求暂时注释，对比新版效果，上线时间 10.30-->
      <PgyCommonSdk
        v-if="showMarketModal && !riskControl"
        v-pgy-collect="{ moduleName: 12076 }"
        :pos-id="12076"
        :swimlane="testSwimLane"
        :utm_source="utmSource"
        :env="runtime"
        @adClick="onMarketModalAdClick"
      />

      <!-- 常见问题模块 -->
      <common-problem
        v-if="showQuestionList"
        v-pgy-collect="{ moduleName: 'question' }"
        :question-list="questionList"
      />
      <!-- 常见问题模块 -->
      <bottom-safety-tips :show-insurance="true" />
    </div>

    <!-- 调研资源位横幅 -->
    <PgyCommonSdk v-if="isNative" class="pgy-13499" :pos-id="13499" :utm_source="utmSource" :env="runtime" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { getAllQueryString } from '@mx/util/get-all-query-string';
import { PgyUtils, PgyCommonSdk } from '@fdfe/marketing-sdk/src/lib/index';
import { refreshPage, fetchMainpageData, fetchLatestBalance } from '@/service/fetchIndexData';
import {
  env,
  bridge,
  monitor,
  analytics,
  analyticConfig,
  runtime,
  Runtime,
  BalanceType,
  metricPoints,
  removeStorage,
  request,
  scrollTo,
  indexFuncModal,
  INDEX_NAV_OPTIONS,
} from '@/common';
import { EventBus } from '@/service/eventBus';
import { riskModal } from '@/service/riskControl';
import MainInfo from './components/MainInfo.vue';
import CommonProblem from './components/CommonProblem.vue';
import BottomSafetyTips from '../../components/BottomSafetyTips.vue';
import TitleBar from '@/components/TitleBar.vue';
import BalanceDetail from './components/BalanceDetail.vue';
import Pgy from './components/Pgy.vue';
import { CollectorUtil } from '@/common/pgyCollect/CollectorUtil';
import { navComponent } from '@/utils/createNav';

export default Vue.extend({
  name: 'IndexV2',

  components: {
    MainInfo,
    PgyCommonSdk,
    Pgy,
    BalanceDetail,
    CommonProblem,
    BottomSafetyTips,
    TitleBar,
  },

  data() {
    const getRuntime = runtime > 2 ? 'test' : Runtime[runtime].toLocaleLowerCase();
    return {
      system: env.system,
      app: env.app,
      isNative: env.isNative,
      isWXMini: env.inWeixinMini,
      layerType: env.layerType,
      utmSource: env.utmSource,
      scene: env.scene,
      runtime: getRuntime,
      dpTop: 0,
      titleBarBg: false,
      pageData: env.indexData,
      showMarketModal: true,
      questionList: [],
      showQuestionList: false,
      testSwimLane: '48218-kaacb',
      borrowPgyVisible: false,
      getDeviceBgImg: '',
      showMore: true,
      rewardAmount: -999,
      cognitionDiamondPgyVisible: false,
      cognitionNoticePgyVisible: false,
      pageSync: false,
      balanceDetail: {} as ILatestDetail,
      newTaskPgyDataReady: false,
    };
  },

  computed: {
    isMiniProgramWalletLayer(): boolean {
      return env.isWXMiniProgram && env.layerType === 'wallet';
    },
    showBindCardEntry(): boolean {
      return this.pageData.balanceType === BalanceType.QuanYiJin;
    },
    titleBarText(): string {
      return this.showBindCardEntry ? '余额（仅可提现）' : '美团余额';
    },

    riskControl(): boolean {
      return !!(this.pageData.rechargeStatus || this.pageData.withdrawStatus);
    },
    getInMiniStyle(): boolean {
      return !this.isNative;
    },
    cognitionVisible(): boolean {
      // 金刚位和公告栏组件有一个下发就展示
      return this.isNative && (this.cognitionDiamondPgyVisible || this.cognitionNoticePgyVisible);
    },
    showNewTaskPgy(): boolean {
      return this.isNative && !this.borrowPgyVisible && this.newTaskPgyDataReady;
    },
  },

  created() {
    removeStorage('VERIFIED_RESULT_SUCCESS');
    PgyUtils.reportPgyTTI('created');
    this.setDeviceBgImg();
    if (!this.isNative) {
      document.title = this.titleBarText;
    }
  },
  activated() {
    if (!this.isNative) {
      setTimeout(() => {
        window.addEventListener('pageshow', () => {
          this.refreshPageData();
        });
      }, 0);
    }
  },
  mounted() {
    // 禁止页面反弹
    bridge.setBounces(0);
    if (!(window as any).haveReportedTTI) {
      monitor.sendPoint();
    }
    this.initListener();
    this.$nextTick(() => {
      analytics.pv(analyticConfig.index.cid, CollectorUtil.getMetricReportData());
      monitor.reportMetric(metricPoints.index, { isHarmony: env.isHarmony });
      this.addEventScroll();
    });

    if (this.riskControl) riskModal(this.pageData.riskControlAlert);

    if (this.isNative) {
      this.fetchRewardAmountData();
    }
    setTimeout(() => {
      this.scrollToTargetElement();
    }, 1500);
    monitor.captureMessage('【入口】余额首页');
  },

  methods: {
    initListener() {
      EventBus.$on('pageApiReady', () => {
        this.pageSync = true;
      });

      EventBus.$on('updatePageData', () => {
        this.pageData = env.indexData;
        this.$nextTick(() => {
          // 微信小程序钱包显示浮层，业务页面加载完毕时调用该方法
          if (env.isWXMiniProgram && env.layerType === 'wallet' && window.parent) {
            window.parent.postMessage(
              {
                type: 'walletLayer',
                method: 'showLayer',
              },
              '*'
            );
          }
        });
      });

      EventBus.$on('setLatestBalanceDetail', (data: ILatestDetail) => {
        this.balanceDetail = data || {};
      });

      EventBus.$on('setQuestionList', (config: any) => {
        this.questionList = config?.list?.length > 0 ? config?.list : [];
        this.showQuestionList = config?.list?.length > 0;
        analytics.mv(analyticConfig.questionListMv);
      });

      EventBus.$on('updateRewardAmountData', () => {
        if (this.isNative) {
          this.fetchRewardAmountData();
        }
      });

      EventBus.$on('updateBalanceDetail', () => {
        fetchLatestBalance();
      });
    },

    closeWalletLayer() {
      if (window.parent) {
        window.parent.postMessage(
          {
            type: 'walletLayer',
            method: 'hideLayer',
          },
          '*'
        );
      }
    },

    setDeviceBgImg() {
      const ehcModalFlag = env.queryStrings.ehcShowModal || '';
      if (env.inWeixinMini) {
        this.getDeviceBgImg = 'wxmini-balance-wrapper';
        return;
      }
      if (env.system === 'android') {
        this.getDeviceBgImg = 'android-balance-wrapper';
        return;
      }
      if (env.system === 'iphone') {
        this.getDeviceBgImg = 'ios-balance-wrapper';
        return;
      }
      if (ehcModalFlag) {
        this.getDeviceBgImg = 'ehc-modal-balance-wrapper';
      }
    },
    onBorrowVisibleChange(val: boolean) {
      if (val) this.borrowPgyVisible = true;
    },
    toClickMore() {
      analytics.click(analyticConfig.navRightButton);
      if (navComponent.isOpen()) {
        navComponent.close();
      } else {
        navComponent.open({
          options: indexFuncModal,
          clickHandler: this.navOptionClickHandler,
        });
      }
    },
    navOptionClickHandler(index: number, item: { id: string; item: keyof typeof INDEX_NAV_OPTIONS }) {
      analytics.click(analyticConfig.navRightFunList, { button_name: item.id });
      bridge.openPage(INDEX_NAV_OPTIONS[item.item]);
    },
    onMarketModalAdClick(position: string) {
      if (position === 'RU' || position === 'img') {
        refreshPage(() => {
          // 返回后直接关闭
          this.showMarketModal = false;
        });
      } else if (position === 'R') {
        this.showMarketModal = false;
      }
    },

    closePage() {
      analytics.click(analyticConfig.backIconMc, {
        from: env.scene,
      });
      setTimeout(() => {
        bridge.closePage();
      }, 50);
    },

    addEventScroll() {
      document.addEventListener('scroll', () => {
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        this.titleBarBg = scrollTop > 8;
        if (navComponent.isOpen()) {
          navComponent.close();
        }
      });
    },

    refreshPageData() {
      fetchMainpageData();
      EventBus.$emit('updateBalanceDetail');
    },

    setGuideInfo(guideInfo: GuideInfoType) {
      env.setIndexData(
        Object.assign(this.pageData, {
          guideInfo,
        })
      );
      this.pageData = env.indexData;
    },

    fetchRewardAmountData() {
      // 查询天天领余额（13271）的今日已赚余额数
      request
        .fetchRewardAmount()
        .then((res) => {
          const { status, data } = res;
          if (status === 'success' && data?.rewardAmount) {
            this.rewardAmount = data.rewardAmount;
          }
        })
        .catch(() => {});
    },

    adClick() {
      bridge.subscribeAppear(() => {
        if (this.isNative) {
          // 更新今日已赚余额数
          this.fetchRewardAmountData();
          this.refreshPageData();
        }
      });
    },

    // 获取滚动的目标元素DOM
    getTargetDOM(): HTMLElement | null {
      const anchor = getAllQueryString()?.anchor || '';
      return (this.$refs[anchor] as HTMLElement) || null;
    },

    // 滚动到目标元素
    scrollToTargetElement() {
      try {
        const targetElement = this.getTargetDOM();
        if (targetElement) {
          const titleBarHeight = document.querySelector('.nav-fixed')?.getBoundingClientRect()?.height || 0;

          // 需要滚动的距离 = 目标元素到视窗的距离 + 已滚动的距离 - titlebar的高度
          const height = targetElement.getBoundingClientRect().top + window.scrollY - titleBarHeight;
          document.documentElement.scrollTop = document.body.scrollTop = height;
          scrollTo(height, 0, 10);
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 心智教育区-金刚位可见性变化
    onCognitionDiamondPgyVisibleChange(val: boolean) {
      this.cognitionDiamondPgyVisible = val;
    },

    // 心智教育区-公告栏可见性变化
    onCognitionNoticePgyVisibleChange(val: boolean) {
      this.cognitionNoticePgyVisible = val;
    },
    onCustomEvent(params: { eventType: string; shouldDisplay: boolean }) {
      // 因为存在有广告数据下发，但实际受任务达标影响，最终不展示的情况，所以通过业务事件DATA_READY来判断最终是否展示这个组件。
      const { eventType, shouldDisplay } = params || {};
      this.newTaskPgyDataReady = eventType === 'DATA_READY' && shouldDisplay;
    },
  },
});
</script>

<style lang="less" scoped>
@import '../../styles/indexV2.less';

.func-and-title {
  position: relative !important;
  .main-nav {
    background: transparent;
    /deep/ .nav-left {
      left: -0.06rem;
    }
    /deep/ .nav-right {
      right: -0.06rem;
      background: transparent !important;
    }
  }
  .linear-gradient {
    background: #ffffff;
  }
  .miniprogram-titlebar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 1.08rem;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    &-scrolled {
      background: #ffffff;
    }
    .title {
      font-family: PingFangSC-Medium;
      font-size: 0.36rem;
      color: #191919;
      letter-spacing: 0;
      text-align: center;
      line-height: 0.36rem;
      font-weight: 500;
    }
    .close-float {
      position: absolute;
      top: 0.36rem;
      right: 0.32rem;
      background: url(../../assets/icon-float-close.png) 100% / contain no-repeat;
      width: 0.35rem;
      height: 0.35rem;
    }
  }
}
.balance-wrapper {
  min-height: 100vh;
  position: relative;
  padding: 1.06rem 0.24rem 2rem;
  padding-top: calc(1.06rem + constant(safe-area-inset-top));
  padding-top: calc(1.06rem + env(safe-area-inset-top));
  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 5.4rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    background: transparent url('https://p1.meituan.net/wxapp/a986e4651bd21d7df867005e19ebc22e38237.png') no-repeat
      center center / cover;
    background-size: 100% 6rem;
  }
}
.mini-balance-wrapper {
  padding-top: 0.32rem;
}
.mini-balance-wallet-layer-wrapper {
  padding-top: 1.2rem;
}
.dp-ios {
  padding-top: calc(0.1rem + constant(safe-area-inset-top));
  padding-top: calc(0.1rem + env(safe-area-inset-top));
}
.wxmini-balance-wrapper {
  &::before {
    height: 4.22rem !important;
    background-size: 100% 4.22rem !important;
  }
}
.android-balance-wrapper {
  &::before {
    height: 5.22rem !important;
    background-size: 100% 5.22rem !important;
  }
}
.ios-balance-wrapper {
  &::before {
    height: 6.22rem !important;
    background-size: 100% 6.22rem !important;
  }
}
.ehc-modal-balance-wrapper {
  &::before {
    height: 5.22rem !important;
    background-size: 100% 5.22rem !important;
  }
}
.balanceDetail {
  margin-top: 0.2rem;
}
.cognition {
  margin-top: 0.2rem;
  background: #fff;
  border-radius: 0.24rem;

  .pgy-13506 {
    padding: 0.3rem 0 0.16rem 0;
  }

  .divide {
    margin: 0 0.24rem;
    height: 0.01rem;
    background: #f4f4f4;
  }

  .pgy-13505 {
    padding: 0.26rem 0;
  }
}
.pgy-12833 {
  margin-top: 0.2rem;
}
.pgy-mid-promotion {
  margin-top: 0.2rem;
  border-radius: 0.24rem;
  padding-top: 0.2rem;
  background: #fff;
}
.pgy-12826 {
  margin-top: 0.2rem;
}
.pgy-13271 {
  margin-top: 0.2rem;
}
.pgy-12835 {
  margin-top: 0.2rem;
}
.top-tips {
  margin-bottom: 0.24rem;
}
.pgy-12167-title {
  padding: 0.16rem 0.24rem 0;
  opacity: 0.9;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.32rem;
  color: #000;
  line-height: 0.32rem;
  font-weight: 700;
}
.pgy-12167 {
  padding: 0 0.24rem;
}

/deep/ .pgy-ad-balancemission {
  width: 100% !important;
  background: #fff !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
